export default __webpack_public_path__ + "static/screeny-55-gp-xs-1-04e917b8dcf5191ff2c3f8a38c011f29.jpg";